/* Read the builder's existing saved order; never create, rewrite, or clear it here. */
(() => {
  const resume = document.querySelector('[data-home-resume]');
  if (!resume) return;
  const openLink = document.querySelector('[data-open-builder]');
  const previews = resume.querySelector('[data-resume-previews]');
  let items = [];
  let revision = 0;

  function readSavedOrder() {
    return new Promise((resolve, reject) => {
      // Same database, store, and key as order-builder.liquid / dtf-builder.js.
      const request = indexedDB.open(resume.dataset.sessionNamespace || 'DTFBuilderDB', 1);
      request.onupgradeneeded = () => request.transaction.abort();
      request.onerror = () => reject(request.error);
      request.onblocked = () => resolve(null);
      request.onsuccess = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains('sessionStore')) {
          db.close(); resolve(null); return;
        }
        const tx = db.transaction('sessionStore', 'readonly');
        const saved = tx.objectStore('sessionStore').get('dtf_builder_session');
        tx.oncomplete = () => { db.close(); resolve(saved.result); };
        tx.onabort = tx.onerror = () => { db.close(); reject(tx.error); };
      };
    });
  }

  function thumbnail(item) {
    const tile = document.createElement('span');
    tile.className = 'resume-thumb';
    tile.textContent = 'PNG';
    const source = item.thumbUrl;
    if (typeof source === 'string' && /^(https:\/\/|data:image\/(png|jpeg|webp|gif);)/i.test(source)) {
      const image = document.createElement('img');
      image.alt = '';
      image.width = 56; image.height = 56;
      image.decoding = 'async';
      image.addEventListener('error', () => { tile.textContent = 'PNG'; }, { once: true });
      image.src = source;
      tile.replaceChildren(image);
    }
    return tile;
  }

  function renderPreviews() {
    if (resume.hidden) return;
    // One complete row. Reserve the last tile for the number of remaining designs.
    const slots = Math.max(1, Math.floor((previews.clientWidth + 8) / 64));
    const shown = items.length > slots ? Math.max(0, slots - 1) : items.length;
    const tiles = items.slice(0, shown).map(thumbnail);
    if (shown < items.length) {
      const more = document.createElement('span');
      more.className = 'resume-more';
      more.textContent = '+' + (items.length - shown);
      tiles.push(more);
    }
    previews.replaceChildren(...tiles);
  }

  async function refresh() {
    const current = ++revision;
    let saved;
    try { saved = await readSavedOrder(); } catch { saved = null; }
    if (current !== revision) return;
    items = Array.isArray(saved?.items)
      ? saved.items.filter(item => item && typeof item.r2Key === 'string' && item.r2Key && !item.isRemoved)
      : [];
    resume.hidden = items.length === 0;
    openLink.hidden = items.length > 0;
    renderPreviews();
  }

  if (typeof ResizeObserver === 'function') new ResizeObserver(renderPreviews).observe(previews);
  else window.addEventListener('resize', renderPreviews);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  refresh();
})();
